<template>
  <main>
    <wl-banner bgUrl='/static/img/product/lims/banner.png' :bannerData='bannerData' paddingTop='214px'></wl-banner>
    <breadcrumb></breadcrumb>
    <section class="page1 bg" v-lazy:background-image="'/static/img/product/lims/bg1.png'">
      <article class="container">
        <wl-title title='您是否遇到这些困扰' :isNeedDesc=false class="title"></wl-title>
        <h3 v-for="(i,idx) in page1Data" :key="idx">{{i}}</h3>
      </article>
    </section>
    <section class="page2 bg" v-lazy:background-image="'/static/img/product/lims/bg2.png'">
      <article class="container">
        <wl-title title='全流程业务管理，助力检测检测机构提质增效' :isNeedDesc=false></wl-title>
        <section class="flexWrap">
          <section class="box" v-for="(item,idx) in page2Data" :key="item.key">
            <section class="flex align-center">
              <section class="_icon " :style="`background-position: -${40*idx}px 0px;`"></section>
              <h3>{{item.title}}</h3>
            </section>
            <p>{{item.desc}}</p>
          </section>
        </section>
      </article>
    </section>
    <section class="page3 bg" v-lazy:background-image="'/static/img/product/lims/bg3.png'">
      <article class="container">
        <wl-title title='实验室信息管理系统 ProLIMS 帮您解决' :isNeedDesc=false></wl-title>
        <section v-for="(i,idx) in page3Data" :key="idx" class="box" :class="'b'+idx">
          <h3 class="c-3254C2">{{i.title}}</h3>
          <p>{{i.desc}}</p>
        </section>
      </article>
    </section>
    <section class="page4 bg" v-lazy:background-image="'/static/img/product/lims/bg4.png'">
      <article class="container">
        <wl-title title='实验室信息管理系统ProLIMS' desc='挖掘出每个实验室检测业务管理的价值'></wl-title>
        <section class="flex">
          <h3 v-for="(i,idx) in page4Data" :key="idx" class="c-3254C2" :class="'b'+(idx+1)">{{i}}</h3>
        </section>
      </article>
    </section>
    <submit-page></submit-page>
  </main>
</template>

<script>
export default {
  name: 'limsSystem',
  data() {
    return {
      bannerData: {
        title: '实验室信息管理系统LIMS',
        desc: '符合ISO/IEC17025标准的人、机、料、法、环全面资源管理\n电子化   无纸化   智能化   规范化'
      },
      page1Data: ['样品数量大，形式复杂，工作繁琐?', '人工操作纸质记录，出错率高，效率低?', '检测进度无跟踪管理，还在电话咨询?', '数据不能共享，无法智能分析精细管理?', '仪器设备管理混乱，无法定期检查?'],
      page2Data: [
        { key: 'lims-icon1', title: '检测管理', desc: '检测任务分配、结果登记、数据审核、复\n检等功能' },
        { key: 'lims-icon2', title: '业务受理', desc: '业务委托受理登记、样品登记、样品标签\n打印、计费和送样审核等' },
        { key: 'lims-icon3', title: '样品管理', desc: '样品登记、核查、接收、分样、分样、留\n样、采样全流程管理' },

        { key: 'lims-icon4', title: '资源管理', desc: '检测项目和方法标准管理\n人员管理、仪器管理、试剂管理' },
        { key: 'lims-icon5', title: '质量管理', desc: '检测审批工作、质量评审，严格控制检测\n质量' },
        { key: 'lims-icon6', title: '分包管理', desc: '客户信息管理，分包单位、分包项目管理,\n轻松维护' },

        { key: 'lims-icon7', title: '报告管理', desc: '按模版自动生成检测报告，在线审核签发、\n打印发放，归档' },
        { key: 'lims-icon8', title: 'ELN 管理', desc: '自动采集录入的数据，并计算出检测结果,\n根据检测结果，判断是否通过' },
        { key: 'lims-icon9', title: '数据管理', desc: '数据多维度统计分析，自定义查询各类信息' },
      ],
      page3Data: [
        { title: '告别纸质记录，全流程在线工作', desc: '检测业务管理、样品管理、报告管理、仪器\n管理、质量管理等工作无纸化、智能化办公' },
        { title: '任务驱动，帮您规划繁杂的工作', desc: '任务可自动或手动分配，信息同步给其他人员\n预约消息、审批消息、超时消息、提醒消息' },
        { title: '报告生成，自动化工具轻松搞定', desc: '根据对应的报告模板，智能抓取信\n息，一键生成检测报告预览并打印' },
        { title: '流程监控，每个环节智能记录，省心省力', desc: '二维码作为追溯码，精确的追溯到每个样品的检测\n数据，流程管控省心省力' },
        { title: '电子记录，数据及时共享分析高效决策', desc: '原始记录表电子化，数据实时共享、多维统计分析，所见即所得' },
      ],
      page4Data: ['降低\n管理成本', '减少\n重复工作', '强化\n流程达控', '明晰\n过程溯源', '减化\n数据利用', '提高\n资源共享'],
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/product/lims/icon.png");
}
main {
  background: #fbfbff;
}
h3 {
  font-size: 22px;
  font-weight: 500;
  color: #262626;
  line-height: 22px;
}
p {
  font-size: 18px;
  color: #8e8e8e;
  line-height: 30px;
  white-space: pre-line;
}
.c-3254C2 {
  color: #3254c2;
}
.page1 {
  height: 861px;
  padding-top: 136px;
  .title {
    padding-bottom: 95px;
  }
  h3 {
    width: 530px;
    line-height: 62px;
    margin-bottom: 26px;
    margin-left: 720px;
    text-align: left;
    padding-left: 86px;
  }
}
.page2 {
  height: 968px;
  .container {
    width: 1270px;
  }
  .flexWrap {
    padding-top: 325px;
  }
  .box {
    width: 422px;
    height: 154px;
    padding: 27px 31px;
    padding-right: 0;
    text-align: left;
    ._icon {
      width: 40px;
      height: 40px;
      margin-right: 14px;
      display: inline-block;
    }
    p {
      padding-top: 9px;
      letter-spacing: 1px;
    }
  }
}
.page3 {
  height: 894px;
  .container {
    position: relative;
    padding-top: 136px;
  }
  .box {
    position: absolute;
    text-align: left;
    p {
      color: #5e6974;
      padding-top: 18px;
    }
  }
  .b0 {
    top: 306px;
    left: 35px;
    width: 342px;
    text-align: right;
  }
  .b1 {
    top: 321px;
    width: 360px;
    left: 886px;
  }
  .b2 {
    top: 508px;
    left: 89px;
    width: 308px;
    text-align: right;
  }
  .b3 {
    top: 493px;
    width: 396px;
    left: 846px;
  }
  .b4 {
    top: 693px;
    left: 378px;
    width: 504px;
    text-align: center;
  }
}
.page4 {
  padding-top: 136px;
  height: 653px;
  ::v-deep strong {
    color: #8e8e8e;
  }
  h3 {
    white-space: pre-line;
    width: 88px;
    line-height: 38px;
    padding-top: 162px;
  }
  .flex {
    padding-left: 14px;
  }
  .b1 {
    margin-right: 148px;
  }
  .b2 {
    margin-right: 150px;
  }
  .b3 {
    margin-right: 138px;
  }
  .b4 {
    margin-right: 135px;
  }
  .b5 {
    margin-right: 134px;
  }
}
</style>
